import {
  DataGrid,
  DateBox,
  DropDownBox,
  List,
  SelectBox,
} from "devextreme-react";
import {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import moment from "moment";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { axiosGet } from "../../apis/useAxios";
import DataSource from "devextreme/data/data_source";
import { getRequestParams } from "../../helpers/globalfunctions";

export default function ActivityRawDataComponent() {
  const [state, setState] = useState({
    isFilterSubmitted: false,
    isActivityApiLoading: false,
    filterDropdownEmployeeDataSource: [],
    filterEmployeeNumber: "",
    filterDatetime: new Date(moment().startOf("day")),
    crewActivityGridDataSource: [],
  });
  const refDataGrid = useRef();
  const refLstEmployees = useRef(null);
  useLayoutEffect(() => {
    document.querySelector("#lblPageTitle").innerHTML = `Raw Data`;
  });
  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnLoad = async () => {
    try {
      setTimeout(async () => {
        await GetfilterDropdownEmployee();
      }, 0);
      setTimeout(async () => {
        await getCrewRawData();
      }, 0);
    } catch (error) {
      console.log(error);
    }
  };
  const GetfilterDropdownEmployee = async () => {
    try {
      debugger;
      const res = await axiosGet(`/Crew/get-crew-dropdown`, {
        AirlineCode: sessionStorage.getItem("session_airlineCode"),
      });
      setState((prev) => ({
        ...prev,
        filterDropdownEmployeeDataSource: res?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const handleOnFilterGridDataSource = async () => {
    try {
      setState((prev) => ({
        ...prev,
        isFilterSubmitted: true,
        isActivityApiLoading: true,
      }));
      await getCrewRawData();
      setState((prev) => ({
        ...prev,
        isFilterSubmitted: false,
        isActivityApiLoading: false,
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const getCrewRawData = async () => {
    try {
      debugger;
      var request = {};
      request.AirlineCode = sessionStorage.getItem("session_airlineCode");
      request.EmployeeNumber = state.filterEmployeeNumber;
      let res = await fetch(
        process.env.REACT_APP_API_BASE_URL + "CrewActivity/crew-raw-data",
        getRequestParams("POST", request)
      ).then((response) => response.json());
      setState((prev) => ({
        ...prev,
        crewActivityGridDataSource: res.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      <div className="filter-box">
        <div className="card p-2 m-0">
          <div className="row">
            <div className="col-lg-2 col-md-2">
              <div className="form-group">
                <label>Employee Number</label>
                <DropDownBox
                  value={state.filterEmployeeNumber}
                  valueExpr="employeeNumber"
                  displayExpr="employeeName"
                  deferRendering={false}
                  showClearButton={true}
                  dataSource={state.filterDropdownEmployeeDataSource}
                  onValueChanged={() => {
                    refLstEmployees.current.instance.unselectAll();
                    setState((prev) => ({
                      ...prev,
                      filterEmployeeNumber: "",
                    }));
                  }}
                  contentRender={() => {
                    return (
                      <List
                        ref={refLstEmployees}
                        dataSource={
                          new DataSource({
                            store: state.filterDropdownEmployeeDataSource,
                            sort: "employeeName",
                            sortOrder: "asc",
                            paginate: true,
                            pageSize: 10,
                          })
                        }
                        height={400}
                        keyExpr="employeeNumber"
                        displayExpr="employeeName"
                        searchEnabled={true}
                        searchExpr={["employeeNumber", "employeeName"]}
                        searchMode="contains"
                        pageLoadMode="scrollBottom"
                        showSelectionControls={true}
                        selectionMode={"single"}
                        indicateLoading={true}
                        selectByClick={true}
                        onItemClick={(item) => {
                          try {
                            setState((prev) => ({
                              ...prev,
                              filterEmployeeNumber:
                                item?.itemData?.employeeNumber ?? "",
                            }));
                          } catch (error) {
                            console.log("List.onItemClick", error);
                          }
                        }}
                      />
                    );
                  }}
                  placeholder="Select Employee"
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-2">
              <div className="form-group has-feedback">
                <div>
                  <br />
                </div>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={async () => {
                    await handleOnFilterGridDataSource();
                  }}
                >
                  <span title="Search">
                    <i
                      className={`fas fa-${
                        state.isFilterSubmitted ? "spinner fa-spin" : "filter"
                      }`}
                    ></i>
                    &nbsp;Search
                  </span>
                </button>
                &nbsp; &nbsp;
                <button
                  type="button"
                  className="btn btn-custom-gray"
                  onClick={() => {
                    setState((prev) => ({
                      ...prev,
                      filterEmployeeNumber: "",
                    }));
                  }}
                >
                  <span title="Clear">
                    <i className="fas fa-eraser"></i> Clear
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div>
            <DataGrid
              ref={refDataGrid}
              dataSource={state.crewActivityGridDataSource}
              columnAutoWidth={true}
              showColumnLines={true}
              showRowLines={true}
              showBorders={true}
              rowAlternationEnabled={false}
              allowColumnResizing={true}
            >
              <Column
                dataField="id"
                caption=""
                allowSorting={false}
                allowSearch={false}
                allowExporting={false}
                allowFiltering={false}
                fixed={true}
                width={"30"}
                visible={false}
              />
              <Column
                dataField="employeeNo"
                caption="Employee Number"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="activityTime"
                caption="Activity Time"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="activityType"
                caption="Activity Type"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="dutyType"
                caption="Duty Type"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="flyAirportPickup"
                caption="Fly Airport Pickup"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="dutyId"
                caption="Duty #"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="activityCode"
                caption="Activity Code"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="activityLocationCode"
                caption="Activity Location Code"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="baseStation"
                caption="Base Station"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="airportCode"
                caption="Airport Code"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="origin"
                caption="Origin"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="destination"
                caption="Destination"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="sequenceNumber"
                caption="Sequence Number"
                allowSearch={true}
                width={200}
              />

              <Column
                dataField="maximumDutySeq"
                caption="Maximum Duty Seq"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="activityStartTime"
                caption="Activity Start Time"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="activityEndTime"
                caption="Activity End Time"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="flightTime"
                caption="Flight Time"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="flightNumber"
                caption="Flight Number"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="dutyReportingTime"
                caption="Duty Reporting Time"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="deBriefingTime"
                caption="De-Briefing Time"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="airlineType"
                caption="Airline Type"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="createdDateTime"
                caption="Created Date Time"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="notificationBatchId"
                caption="Notification Batch #"
                allowSearch={true}
                width={200}
              />
              <Column
                dataField="requestSessionId"
                caption="Request Session #"
                allowSearch={true}
                width={200}
              />
              <HeaderFilter visible={true} />
              <Paging defaultPageSize={20} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={[10, 20, 50]}
                showInfo={true}
                visible={true}
              />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Export
                enabled={true}
                allowExportSelectedData={false}
                fileName="CrewActivity"
              />
            </DataGrid>
          </div>
        </div>
      </div>
    </div>
  );
}
